import type { Locale } from '../i18n';
import { STRINGS } from '../i18n';
import { Logo } from './Logo';

interface FooterProps {
  locale: Locale;
}

export function Footer({ locale }: FooterProps) {
  const t = STRINGS[locale];
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-6 py-8 sm:flex-row sm:justify-between">
        <Logo size="sm" />
        <p className="text-sm text-slate-500">
          &copy; {year} PocketLedger - {t.footer}
        </p>
        <div className="flex gap-4 text-sm text-slate-500">
          <a className="hover:text-slate-900" href="/about">About</a>
          <a className="hover:text-slate-900" href="/privacy">Privacy</a>
          <a className="hover:text-slate-900" href="/changelog">Changelog</a>
        </div>
      </div>
    </footer>
  );
}
